var endVS = `
`;

export { endVS as default };
